module.exports = __webpack_public_path__ + "static/media/trash.c74a9e4b.svg";